import dynamic from 'next/dynamic';
import { useState } from 'react';

import useLocalStorageState from 'hooks/useLocalStorageState';
import useScrollPosition from 'hooks/useScrollPosition';

import { sendEvent } from 'lib/gtag';

import LOCAL_STORAGE from 'constants/localStorage';

const DownloadAppCTA = dynamic(() => import('components/DownloadAppCTA'), {
  ssr: false,
});
const DynamicLGPDDialogBox = dynamic(() => import('./LGPDDialogBox'), {
  ssr: false,
});

const GA_EVENT_CATEGORY = 'modal_lgpd';

const LGPDDialogBox = () => {
  const [isOpen, setOpen] = useState(false);
  const [isLGPDAlertEnabled, setLGPDAlertEnabled] = useLocalStorageState(
    LOCAL_STORAGE.IS_SHOWING_LGPD_ALERT,
    true
  );
  const [isAppDownloadComponentsEnabled, setAppDownloadComponentsEnabled] =
    useState(false);

  useScrollPosition(
    () => {
      if (isLGPDAlertEnabled && !isOpen) {
        sendEvent({ action: 'show', category: GA_EVENT_CATEGORY });
        setOpen(true);
      }
    },
    { deps: [isLGPDAlertEnabled, isOpen] }
  );

  const onGiveAllConsentsClick = () => {
    setLGPDAlertEnabled(false);
    setOpen(false);
    setAppDownloadComponentsEnabled(true);
  };

  if (isAppDownloadComponentsEnabled) {
    return <DownloadAppCTA initialOpenState />;
  }

  if (!isOpen) {
    return null;
  }

  return (
    <DynamicLGPDDialogBox
      gaEventCategory={GA_EVENT_CATEGORY}
      onGiveAllConsentsClick={onGiveAllConsentsClick}
    />
  );
};

export default LGPDDialogBox;
